import React from 'react';
import { Box, Chip } from '@mui/material';

// Band visibility toggles for a grid toolbar; any band can be turned off, but at least one stays selected
const BandControl = ({ options, bands, onChange, colors }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', mr: 1 }} role="group" aria-label="Status bands shown">
        {options.map((band) => {
            const selected = bands.includes(band);
            return (
                <Chip
                    key={band}
                    label={band}
                    size="small"
                    variant={selected ? 'filled' : 'outlined'}
                    aria-pressed={selected}
                    onClick={() => {
                        const next = selected ? bands.filter((b) => b !== band) : [...bands, band];
                        if (next.length > 0) onChange(next);
                    }}
                    sx={selected
                        ? { backgroundColor: colors[band].bg, color: colors[band].fg, fontSize: '12px' }
                        : { color: 'text.secondary', fontSize: '12px' }}
                />
            );
        })}
    </Box>
);

export default BandControl;
